import PropTypes from 'prop-types';

const Header = ({ icon, title, titleColor = 'text-gray-900' }) => (
  <div className={'flex items-center justify-between w-full'}>
    <div className="flex items-center gap-16">
      <img src={icon} alt="Icon" />
      <h1 className={`sm:text-xl 2xl:text-2xl font-semibold ${titleColor}`}>
        {title}
      </h1>
    </div>
  </div>
);

Header.propTypes = {
  icon: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  titleColor: PropTypes.string,
};

export default Header;
